import { queryClient } from '@/client/query';
import { useMutation, useQuery } from '@tanstack/react-query';
import questionnaireRepository from '../repositories/questionnaire.repository';

export function useGetQuestionnaire(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['questionnaire', 'get'],
    queryFn: questionnaireRepository.get,
    gcTime: 0,
    enabled: options?.enabled !== false,
  });
}

export function useAnswerQuestionnaire() {
  return useMutation({
    mutationFn: questionnaireRepository.sendAnswer,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['questionnaire', 'get'] });
    },
  });
}
